import { render, staticRenderFns } from "./PositionPop.vue?vue&type=template&id=2ef1dde6&"
import script from "./PositionPop.vue?vue&type=script&lang=js&"
export * from "./PositionPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports